export function gain_produce(pid) {
	if (pid) {

		let temp_produce = false;
		for (let i in produce) {
			if (produce[i]['p_id'] === pid) {
				temp_produce = produce[i];
				break;
			}
		}

		switch (temp_produce['p_id']) {
			case 'pidfilepoc_zbwjd': {
				temp_produce['table'] = createPid_zbwjd();
				break;
			}
			case 'pidfilepoc_hbwjd': {
				temp_produce['table'] = createPid_hbwjd();
				break;
			}
		}

		return temp_produce;
	}
}

const produce = [
	{ p_id: 'pidfilepoc_hbwjd', choose: false, p_name: '标准文件袋' },
	{ p_id: 'pidfilepoc_zbwjd', choose: false, p_name: '专版文件袋' },
]

// 标准文件袋
function createPid_hbwjd() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichun', 'chichunstr'],
			data: [
				{ type: 'default', name: '330高*240宽*30起墙', value: [330, 240, '330高*240宽*30起墙'], choose: true },
				{ type: 'custom3', name: '自定义展开尺寸', value: [429, 582, 30, '429*582', '展开尺寸:429×582×30'], choose: false },
			]
		},
		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准刀模', value: '标准刀模', choose: true },
				// { type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		// 纸张
		p_zhizhnag: {
			name: '纸张',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '双胶纸', value: '5', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双铜纸', value: '1' },
						{ name: '单铜纸(白卡)', value: '2' },
						{ name: '哑粉纸', value: '3' },
						{ name: '双胶纸', value: '5' },
						{ name: '黄牛皮', value: '9' },
						{ name: '白牛皮', value: '14' },
					]
				},
				{
					type: 'select', name: '120克', value: 120, choose: true, level: '2', select_show: false, select_data: [
						{ name: '100克', value: 100 },
						{ name: '120克', value: 120 },
						{ name: '140克', value: 140 },
						{ name: '160克', value: 160 },
						{ name: '200克', value: 200 },
						{ name: '250克', value: 250 },
					]
				},
			],
			multi_list: [
				// 双铜纸
				[
					{ name: '105克', value: 105 },
					{ name: '120克', value: 120 },
					{ name: '128克', value: 128 },
					{ name: '140克', value: 140 },
					{ name: '150克', value: 150 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 单铜纸
				[
					{ name: '190克', value: 190 },
					// {name:'200克', value:200},
					{ name: '210克', value: 210 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					// {name:'400克', value:400},
				],
				// 哑粉纸
				[
					{ name: '105克', value: 105 },
					{ name: '128克', value: 128 },
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '350克', value: 350 },
					{ name: '400克', value: 400 },
				],
				// 双胶纸
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 黄牛皮
				[
					{ name: '80克', value: 80 },
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
					{ name: '310克', value: 310 },
					{ name: '350克', value: 350 },
					{ name: '360克', value: 360 },
					{ name: '400克', value: 400 },
					{ name: '410克', value: 410 },
					{ name: '450克', value: 450 },
				],
				// 白牛皮
				[
					{ name: '100克', value: 100 },
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
			]
		},
		// 纸张
		// p_zhizhnag: {
		// 	name: '纸张',
		// 	container: ['cailiao', 'yongzhi'],
		// 	data_multi: [
		// 		{type:'select',  name:'国产黄牛皮', value:'国产黄牛皮', choose:true, level:'1', select_show:false, select_data:[
		// 			{name:'国产黄牛皮',			  value:'国产黄牛皮'},
		// 			{name:'进口黄牛皮',			  value:'进口黄牛皮'},
		// 			{name:'进口白牛皮',			  value:'进口白牛皮'},

		// 		]},
		// 		{type:'select',  name:'150克', value:150, choose:true, level:'2', select_show:false, select_data:[
		// 			{name:'150克', value:150},
		// 		]},
		// 	],
		// 	multi_list: [
		// 		//国产黄牛皮
		// 		[
		// 			{name:'150克', value:150},
		// 		],
		// 		//进口黄牛皮
		// 		[
		// 			{name:'180克', value:180},
		// 			{name:'250克', value:250},
		// 		],
		// 		//进口白牛皮
		// 		[
		// 			{name:'200克', value:200},
		// 			{name:'250克', value:250},
		// 		],
		// 	]
		// },
		// 印刷款数
		p_kuanshu: {
			name: '印刷款数',
			container: 'pinzhong',
			data: [
				{ type: 'default', name: '1', value: 1, choose: true, },
				{ type: 'default', name: '2', value: 2, choose: false, },
				{ type: 'default', name: '3', value: 3, choose: false, },
				{ type: 'default', name: '4', value: 4, choose: false, },
				{ type: 'default', name: '5', value: 5, choose: false, },
				{ type: 'default', name: '6', value: 6, choose: false, },
				{ type: 'default', name: '7', value: 7, choose: false, },
				{ type: 'custom1', name: '', value: 9, choose: false, },
			],
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '100', value: 100, choose: false },
				{ type: 'default', name: '200', value: 200, choose: false },
				{ type: 'default', name: '500', value: 500, choose: true },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'custom1', name: '', value: 20000, choose: false },
			]
		},
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '彩色', choose: true },
				{ type: 'default', name: '双色', value: '双色', choose: false },
				{ type: 'default', name: '单色', value: '单色', choose: false },
				{ type: 'default', name: '无', value: '', choose: false },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '起墙', value: '起墙', choose: true },
					]
				},
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '打鸡眼', value: '打鸡眼', choose: true },
						{ type: 'default', name: '魔术贴', value: '魔术贴', choose: false },
					]
				},

			]
		}
	}
}

// 专版文件袋
function createPid_zbwjd() {
	return {
		// 成品尺寸
		p_chengpinchicun: {
			name: '成品尺寸',
			container: ['xx', 'yy', 'chichunstr', 'chichun'],
			data: [
				{
					type: 'select', name: '标准款240X330X30X50mm', value: [554, 408, '429*582'], choose: true, select_show: false, select_data: [
						{ name: '标准款240X330X30X50mm', value: [554, 408, '429*582', '文件袋(330×240×30)'], choose: true },
						{ name: '加大款240X340X40X60mm', value: [578, 429, '429*582', '文件袋(330×240×30)'], choose: false },
					]
				},
				// {type:'default', name:'标准款240X330X30X50mm', value:[554, 408, '', '429*582', '文件袋(330×240×30)'], choose:true},
				// {type:'default', name:'加大款240X340X40X60mm', value:[578, 429, '', '429*582', '文件袋(330×240×30)'], choose:false},
				{ type: 'custom3', name: '自定义展开尺寸', value: [429, 582, '429*582', '展开尺寸:429×582×30'], choose: false },
			]
		},
		// 刀模
		p_daomo: {
			name: '刀模',
			container: 'daomo',
			data: [
				{ type: 'default', name: '标准刀模', value: '0', choose: true },
				// { type: 'default', name: '定制刀模', value: '1', choose: false },
			]
		},
		// 纸张
		p_zhizhnag: {
			name: '纸张',
			container: ['cailiao', 'yongzhi'],
			data_multi: [
				{
					type: 'select', name: '黄牛皮', value: '9', choose: true, level: '1', select_show: false, select_data: [
						{ name: '双铜纸', value: '1' },
						{ name: '单铜纸(白卡)', value: '2' },
						{ name: '哑粉纸', value: '3' },
						{ name: '双胶纸', value: '5' },
						{ name: '黄牛皮', value: '9' },
						{ name: '白牛皮', value: '14' },
					]
				},
				{
					type: 'select', name: '150克', value: 150, choose: true, level: '2', select_show: false, select_data: [
						{ name: '120克', value: 120 },
						{ name: '150克', value: 150 },
						{ name: '180克', value: 180 },
						{ name: '200克', value: 200 },
						{ name: '250克', value: 250 },
						{ name: '300克', value: 300 },
					]
				},
			],
			multi_list: [
				// 双铜纸
				[
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 单铜纸
				[
					{ name: '210克', value: 210 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 哑粉纸
				[
					{ name: '157克', value: 157 },
					{ name: '200克', value: 200 },
					// { name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 双胶纸
				[
					{ name: '120克', value: 120 },
					{ name: '140克', value: 140 },
					{ name: '160克', value: 160 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
				],
				// 黄牛皮
				[
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
				// 白牛皮
				[
					{ name: '120克', value: 120 },
					{ name: '150克', value: 150 },
					{ name: '180克', value: 180 },
					{ name: '200克', value: 200 },
					{ name: '230克', value: 230 },
					{ name: '250克', value: 250 },
					{ name: '300克', value: 300 },
				],
			]
		},
		
		// 印刷颜色
		p_yinshuayanse: {
			name: '印刷颜色',
			container: 'ysys',
			data: [
				{ type: 'default', name: '彩色', value: '4', choose: true },
				{ type: 'default', name: '双色', value: '2', choose: false },
				{ type: 'default', name: '单色', value: '1', choose: false },
				{ type: 'default', name: '无', value: '0', choose: false },
			]
		},
		// 印刷数量
		p_yinshuashuliang: {
			name: '印刷数量',
			container: 'shuliang',
			data: [
				{ type: 'default', name: '500', value: 500, choose: true },
				{ type: 'default', name: '1000', value: 1000, choose: false },
				{ type: 'default', name: '2000', value: 2000, choose: false },
				{ type: 'default', name: '3000', value: 3000, choose: false },
				{ type: 'default', name: '5000', value: 5000, choose: false },
				{ type: 'default', name: '10000', value: 10000, choose: false },
				{ type: 'custom1', name: '', value: 10000, choose: false },
			]
		},
		//后道工序
		p_houdaogongxu: {
			name: '后道工序',
			data_after: [
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '模切', value: '模切', choose: true },
					]
				},
				{
					container: 'hjg',
					must: true,
					reduce: true,
					data: [
						{ type: 'default', name: '起墙', value: '起墙', choose: true },
					]
				},
				// {
				// 	container: 'hjg',
				// 	must: false,
				// 	reduce: true,
				// 	data: [
				// 		{ type: 'default', name: '打鸡眼', value: '打鸡眼', choose: true },
				// 	]
				// },
				{
					container: 'hjg',
					must: false,
					data: [
						{ type: 'default', name: '打鸡眼', value: '打鸡眼', choose: true },
						{ type: 'default', name: '贴魔术贴', value: '打鸡眼', choose: false },
					]
				},
				{ container: '', must: true, data: [] },
				{
					container: "bmcl",
					must: false,
					data: [
						{
							type: "select",
							name: "单面亮膜",
							value: "覆亮膜",
							choose: false,
							select_show: false,
							select_data: [
								{ name: "单面亮膜", value: "覆亮膜" },
								{ name: "单面哑膜", value: "覆哑膜" },
								{ name: "单面防刮花哑膜", value: "防刮花哑膜" },
								{ name: "单面触感膜", value: "触感膜" },
								{ name: "单面镭射膜", value: "镭射膜" },
							],
						},
					],
				},
				{
					container: "bmcl",
					must: false,
					data: [
						{
							type: "select",
							name: "单面过光油",
							value: "过光油",
							choose: false,
							select_show: false,
							select_data: [
								{ name: "单面过光油", value: "过光油" },
								{ name: "单面过哑油", value: "过哑油" },
							],
						},
					],
				},
				{
					container: ["tjx", "tjy", "tangCl", "hjg"],
					must: false,
					data: [
						{
							type: "select",
							custom2: true,
							unit: "mm",
							name: "普通平烫",
							value: [150, 150, "25552", "烫金"],
							choose: false,
							select_show: false,
							select_data: [
								{
									name: "普通平烫",
									value: [150, 150, "25552", "烫金"],
								},
								{
									name: "浮雕烫",
									value: [150, 150, "25551", "烫金"],
								},
							],
						},
					],
				},
				{
					container: "tjys",
					must: false,
					data: [
						{
							type: 'select', name: '烫黄金', value: '烫金', choose: false, select_show: false, select_data: [
								{ name: "烫黄金", value: "烫金" },
								{ name: "烫哑金", value: "烫金" },
								{ name: "烫红金", value: "烫金" },
								{ name: "烫蓝金", value: "烫金" },
								{ name: "烫黑金", value: "烫金" },
								{ name: "烫银", value: "烫金" },
								{ name: "烫特殊颜色金", value: "烫金" },
							]
						}
					]
				},
				{
					container: ["jtx", "jty", "hjg",'jtCl'],
					must: false,
					data: [
						{
							type: "select",
							custom2: true,
							unit: "mm",
							name: "普通击凸版",
							value: [90, 50, "击凸","25548"],
							choose: false,
							select_show: false,
							select_data: [
								{ name: "普通击凸版", value:[90, 50, "击凸","25548"], },
								{ name: "加厚击凸版", value: [90, 50, "击凸","25549"], },
							],
						},
					],
				},
			]
		}
	}
}



// WEBPACK FOOTER //
// ./src/seal/proFilePocket.js